import styles from "./styles/player-progress.module.scss";
import sliderStyles from "@/components/common/styles/slider.module.scss";
import React from "react";

interface PlayerProgressProps {
  calculateTime?: (seconds: number) => string;
  musicPlayer: React.RefObject<HTMLAudioElement>;
  progressRef: React.RefObject<HTMLInputElement>;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  duration?: number;
}

const PlayerProgress = ({
  calculateTime,
  musicPlayer,
  progressRef,
  onChange,
  duration = 0,
}: PlayerProgressProps) => {
  const isMusicPlayerDuration =
    musicPlayer.current?.duration && isFinite(musicPlayer.current?.duration);
  return (
    <div className={styles.slider_container}>
      {calculateTime && (
        <div className={styles.duration}>
          {calculateTime(musicPlayer.current?.currentTime || 0)}
        </div>
      )}
      <input
        ref={progressRef}
        className={sliderStyles.slider}
        type="range"
        step="0.01"
        min="0"
        max={isMusicPlayerDuration ? musicPlayer.current?.duration : duration}
        value={musicPlayer.current?.currentTime || 0}
        onChange={onChange}
      />
      {calculateTime && (
        <div className={styles.duration}>
          {calculateTime(
            isMusicPlayerDuration ? musicPlayer.current?.duration : duration,
          )}
        </div>
      )}
    </div>
  );
};

export default PlayerProgress;
